<template>
  <v-container>
    <Breadcrumbs :breadcrumbs="breadcrumbs" />
    <v-form ref="form" lazy-validation>
      <v-row align="center">
        <v-col cols="12" lg="6" class="pt-0 pb-0">
          <v-text-field
            v-model="microInfo.microname"
            class="mx-3 "
            :rules="[rules.required]"
            :class="microInfo.microtext.length != 0 ? 'mt-12' : '' "
            label="Micro Name"
            outlined
            dense
            @keyup.enter="submit"
          ></v-text-field>
        </v-col>
        <v-col>
          <!-- :rules="[rules.required, rules.maxvalue]" -->
          <v-chip
            v-for="(item, index) in microInfo.microtext"
            :key="index"
            close
            @click:close="removeMicroText(index)"
            class="ma-2"
          >
            {{ item }}
          </v-chip>
          <v-text-field
            v-model="NewMicro"
            :rules="[rules.arrayNotEmpty]"
            class="mx-3"
            label="Micro Other Names"
            outlined
            dense
            @blur="addNewMicro"
            @keyup.enter="addNewMicro"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col cols="6" class="pt-0 pb-0">
          <v-switch
            class="mx-3 mb-3"
            v-model="microInfo.status"
            label="Status"
            color="primary"
            hide-details
          ></v-switch>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" class="pt-4 pb-0">
          <template>
        <div id="app">
            <vue-editor class="mx-3" v-model="microInfo.microdesc"></vue-editor>
        </div>
        </template>
        </v-col>
        <v-col cols="12" class="pt-0 pb-0">
              <v-btn
                @click="save"
                color="primary"
                class="float-right mr-3 mt-3"
                :loading="loadingAdd"
              >
                Save
              </v-btn>
            </v-col>
      </v-row>
      
    </v-form>
  </v-container>
</template>

<script>
import Breadcrumbs from "@/components/Global/Breadcrumbs";
import { VueEditor } from "vue2-editor";
export default {
  data() {
    return {
        rules: {
        required: (value) => !!value || "Field required.",
        arrayNotEmpty: () =>
          this.microInfo.microtext.length != 0 ||
          "Field required.",
      },

      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/",
        },
        {
          text: "Microes",
          disabled: false,
          to: "/microes",
        },
        {
          text: "Edit",
          disabled: true,
        },
      ],
      micro: {
        microname: "ddd",
        status: true,
        microtext: [] ,
        microdesc: "test test",
      },
      NewMicro: "",
      loadingAdd : false ,  
      microInfo : '',
    };
  },
  components: {
    Breadcrumbs,
    VueEditor
  },
  created() {
      this.readMicro();
  },
  methods: {
      readMicro(){
            console.log
            this.$store
            .dispatch(
            "GetFromAPI",
            "/admin/micro/" + this.$route.params.id
            )
            .then((response) => {
                console.log(response.data.data.microname)
                this.microInfo = response.data.data
                // this.microdesc = response.data.data.microdesc
            });
        },

    save (){
        if (this.$refs.form.validate() != false) {
        this.loadingAdd = true;
        let DataForm = {
          Param: this.microInfo,
          API: "/admin/micro/" + this.$route.params.id
        };
        this.$store
          .dispatch("PutToAPI", DataForm)
          .then(() => {
            this.$store.dispatch("PushSuccessMsg", 'Micro Updated Done');
             this.$router.push({ name: "Microes" }).catch(() => {});
            this.loadingAdd = false;
          })
          .catch((error) => {
            let errorObj = error.data.data;
            this.loadingAdd = false;
            this.$store.dispatch(
              "PushErrorMsg",
              errorObj[Object.keys(errorObj)[0]][0]
            );
          });
        } else {
            this.$store.dispatch("PushErrorMsg", "Data Not Valid");
        }
      
    },
    addNewMicro() {
        if(this.NewMicro == '' || this.NewMicro == null) {
            return false
        }
      this.microInfo.microtext.push(this.NewMicro);
      this.NewMicro = "";
    },
    removeMicroText(index) {
        console.log(this.micro.microtext.length)
      this.microInfo.microtext.splice(index, 1);
    },
    reset(){
        this.micro.microname = "" ;
        this.micro.status = true ;
        this.micro.microtext = "" ;
        this.micro.microdesc = "" ;
        
        
    }
  },
};
</script>